// URLS
// export const SAMPLE_ENDPOINT = "http://10.151.0.182:8002/api/v1";
// export const DEVICE_ENDPOINT = "http://10.151.0.182:8001/api/v1"

export const SAMPLE_ENDPOINT = process.env.SAMPLE_API_URL;
export const DEVICE_ENDPOINT = process.env.DEVICE_API_URL;
export const AUTH_ENDPOINT = process.env.AUTH_API_URL;
export const LOG_ENDPOINT = process.env.LOG_API_URL;
export const LICENSE_ENDPOINT = process.env.LICENSE_API_URL;

// Property
export const PROPERTY_GET_BY_ID = "getProperty";
export const PROPERTY_GET_ALL = "getAllProperties";
export const PROPERTY_INS_DIR_GET_ALL = "getAllPropertiesInstrumentDirection";
export const PROPERTY_SUBMIT = "submitProperty";
export const PROPERTY_DELETE = "deleteProperty";
export const PROPERTY_GET_ALL_SELECTED_ID = "getAllSelectedProperty";
export const PROPERTY_GET_ALL_SELECTED_CALCULATED_ID =
  "getAllSelectedCalculatedProperty";
export const MEASURED_PROPERTY_GET_ALL = "getAllMeasuredProperties";

export const CALCULATED_PROPERTY_GET_ALL_READING_VALUES =
  "getAllCalculatedPropertyReadingValues";
export const CALCULATED_PROPERTY_GET_ALL_READING_SOURCE =
  "getAllCalculatedPropertyReadingSource";
export const CALCULATED_PROPERTY_GET_ALL_DETAILS =
  "getAllCalculatedPropertyDetails";
export const GET_ALL_PARTITIONS = "getAllPartitions";

// Instrument Type
export const INSTRUMENT_TYPE_GET_BY_ID = "getInstrumentType";
export const INSTRUMENT_TYPE_GET_ALL = "getAllInstrumentTypes";
export const INSTRUMENT_TYPE_SUBMIT = "submitInstrumentType";
export const INSTRUMENT_TYPE_DELETE = "deleteInstrumentType";

export const CHECK_INSTRUMENT_IN_USE = "checkinstrumentinuse";

// Property Type
export const PROPERTY_TYPE_GET_ALL = "getAllPropertyTypes";

// Property Attribute
export const PROPERTY_ATTRIBUTE_GET_ALL = "getAllPropertyAttributes";

// Station
export const STATION_GET_BY_ID = "getStation";
export const STATION_GET_ALL = "getAllStations";
export const STATION_SUBMIT = "submitStation";
export const STATION_DELETE = "deleteStation";

// Grade
export const GRADE_GET_BY_ID = "getGrade";
export const GRADE_GET_ALL = "getAllGrades";
export const GRADE_SUBMIT = "submitGrade";
export const GRADE_DELETE = "deleteGrade";
export const GRADE_ENABLE = "enableGrade";
export const GRADE_DISABLE = "disableGrade";
// Product
export const PRODUCT_GET_BY_ID = "getProduct";
export const PRODUCT_GET_ALL = "getAllProducts";
export const PRODUCT_SUBMIT = "submitProduct";
export const PRODUCT_DELETE = "deleteProduct";
export const PRODUCT_ENABLE = "enableProduct";
export const PRODUCT_DISABLE = "disableProduct";

// SOURCE
export const SOURCE_GET_BY_ID = "getSource";
export const SOURCE_GET_ALL = "getAllSource";
export const SOURCE_SUBMIT = "submitSource";
export const SOURCE_DELETE = "deleteSource";

// INSTRUMENT
export const INSTRUMENT_GET_BY_ID = "getInstrument";
export const INSTRUMENT_GET_ALL = "getAllInstrument";
export const INSTRUMENT_SUBMIT = "submitInstrument";
export const INSTRUMENT_DELETE = "deleteInstrument";
export const INSTRUMENT_GET_ALL_SELECTED_ID = "getAllSelectedInstrument";
export const INSTRUMENT_ENABLE = "enableInstrument";
export const INSTRUMENT_DISABLE = "disableInstrument";
export const INSTRUMENT_CHECK_DUPLICATE_IP = "checkduplicateip";
export const INSTRUMENT_GET_PROPERTY_DETAIL = "getAllPropertyDetail";
export const INSTRUMENT_CHECK_PROPERTY_IN_USE = "checkPropertyInUse";
// DIRECTION
export const DIRECTION_LIST = "directionList";

// NETWORK CONNECTION
export const NETWORK_CONNECTION_LIST = "networkConnectionList";

// TESTPLAN
export const TESTPLAN_GET_BY_ID = "getTestplan";
export const TESTPLAN_GET_ALL = "getAllTestplan";
export const TESTPLAN_SUBMIT = "submitTestplan";
export const TESTPLAN_DELETE = "deleteTestplan";
export const TESTPLAN_DISABLE = "disableTestplan";
export const TESTPLAN_ENABLE = "enableTestplan";

// SAMPLE
export const SAMPLE_GET_BY_ID = "getSample";
export const SAMPLE_GET_ALL = "getAllSample";
export const SAMPLE_POST_ALL = "postAllSample";
export const SAMPLE_SUBMIT = "submitSample";
export const SAMPLE_DELETE = "deleteSample";
export const SAMPLE_ENABLE = "enableSample";
export const SAMPLE_DISABLE = "disableSample";
export const SAMPLE_EXPORT = "exportSample";
export const SAMPLE_STATUS = "getSampleStatus";
export const SAMPLE_DETAIL_LATEST = "getLatestSampleDetail";

// DEVICE
export const DEVICE_GET_BY_ID = "getInstrument";
export const DEVICE_GET_GUID = "getGuid";
export const DEVICE_GET_ENCRYPTED_PASSWORD = "getEncryptedPassword";
export const DEVICE_CONNECTION_DATA = "getConnectionDeviceData";
export const DEVICE_FETCH_DATA = "fetchDeviceData";
export const DEVICE_BACKUP_AND_RESTORE_GET_ALL = "fetchBackupData";

// Measurement
export const SAMPLE_MEASUREMENT_START = "startMeasurement";
export const SAMPLE_MEASUREMENT_MULTIPLE_START = "startMultipleMeasurement";
export const SAMPLE_MEASUREMENT_RESUME = "resumeMeasurement";
export const SAMPLE_MEASUREMENT_STOP = "stopMeasurement";
export const SAMPLE_MEASUREMENT_REMEASURE = "remeasureMeasurement";
export const SAMPLE_MEASUREMENT_MULTIPLE_REMEASURE =
  "remeasureMultipleMeasurement";
export const SAMPLE_MEASUREMENT_PAUSE = "pauseMeasurement";
export const SAMPLE_MEASUREMENT_REJECT = "rejectMeasurement";
export const SAMPLE_MEASUREMENT_MULTIPLE_REJECT = "rejectMultipleMeasurements";
export const SAMPLE_MEASUREMENT_APPROVE = "aproveMeasurement";
export const SAMPLE_MEASUREMENT_MULTIPLE_APPROVE =
  "approveMultipleMeasurements";
export const SAMPLE_MEASUREMENT_GET_DETAILS = "getMeasurementDetailsData";
export const SAMPLE_MEASUREMENT_MEASURED_DETAILS =
  "getMeasurementMeasuredDetails";
export const SAMPLE_MEASUREMENT_KEYEDIN_DETAILS =
  "getMeasurementKeyedInDetails";
export const SAMPLE_MEASUREMENT_KEYEDIN_COUNT_DETAILS =
  "getMeasurementKeyedInCountDetails";
export const SAMPLE_MEASUREMENT_CALCULATED_DETAILS =
  "getMeasurementCalculatedDetails";
export const SAMPLE_MEASUREMENT_COMPLETE = "completeMeasurement";

//new
export const SAMPLE_MEASUREMENT_DETAILS = "getSampleMeasurementDetails";
export const SAMPLE_INSTRUMENT_MEASUREMENT_DETAILS =
  "getSampleInstrumentMeasurementDetails";
export const SELECTED_SAMPLE_INSTRUMENT_MEASUREMENT_DETAILS =
  "getSelectedInstrumentDetails";
export const SAMPLE_MEASUREMENT_KEYEDINS = "getMeasurementKeyedIns";

export const MEASUREMENT_INSTRUMENT_START = "startMeasurementInstrument";
export const MEASUREMENT_INSTRUMENT_STOP = "stopMeasurementInstrument";
export const MEASUREMENT_INSTRUMENT_REMEASURE =
  "remeasureMeasurementInstrument";
export const MEASUREMENT_INSTRUMENT_RESUME = "resumeMeasurementInstrument";

export const MEASUREMENT_OVERVIEW_DETAILS = "measurementOverviewDetails";
// Common
export const ERROR_OCCURRED = "errorOccurred";

// USER
export const USER_GET_BY_ID = "getUser";
export const USER_GET_ALL = "getAllUser";
export const USER_SUBMIT = "submitUser";
export const USER_DELETE = "deleteUser";
export const GET_ALL_USER_ROLES = "getAllUserRoles";
export const USER_CREATE = "createUser";
export const PASSWORD_CHANGE = "changePassword";

// ROLE
export const ROLE_GET_BY_ID = "getRole";
export const ROLE_GET_ALL = "getAllRole";
export const ROLE_SUBMIT = "submitRole";
export const ROLE_DELETE = "deleteRole";
export const ROLE_EDIT = "editRole";

// REPORT
export const REPORT_TEMPLATE_GET_BY_ID = "getReportTemplate";
export const REPORT_TEMPLATE_GET_ALL = "getAllReportTemplate";
export const REPORT_TEMPLATE_SUBMIT = "submitReportTemplate";
export const REPORT_TEMPLATE_DELETE = "deleteReportTemplate";

export const SAMPLE_VALUE_REPORT = "getValueReport";
export const SAMPLE_MEASURED_POSITIONS = "getMeasuredPositions";
export const SAMPLE_KEYEDIN_POSITIONS = "getKeyedinPositions";
export const SAMPLE_CALCULATED_POSITIONS = "getCalculatedPositions";
export const SAMPLE_VALUE_PROPERTIES = "getValueProperties";
export const SAMPLE_REPORT = "getSampleReport";
export const SAMPLE_MEASUREMENT_EDIT = "editSampleMeasurement";

//settings
export const SETTINGS_GET_GENERAL = "getGeneralSettings";
export const SETTINGS_GET_LOGO = "getLogoSettings";
export const SETTINGS_GET_GRAPH_SETTINGS = "getGraphSettings";
export const SETTINGS_GET_THRESHOLD = "getThresholdSettings";
export const SETTINGS_GET_SAMPLE = "getSampleSettings";
export const GENERAL_SETTING_SUBMIT = "submitGeneralSettingData";
export const THRESHOLD_SETTING_SUBMIT = "submitThresholdSettingsData";
export const SAMPLE_SETTING_SUBMIT = "submitSampleSettingsData";
export const SETTINGS_GET_BACKUP_RESTORE = "getBackupRestoreSettings";
export const SETTINGS_GET_BACKUP_RESTORE_XML = "getBackupRestoreSettingsXML";
export const TEST_BACKUP_FOLDER_CONNECTION = "TestBackupFolderConnection";
export const TEST_BACKUP_SAMPLE_FOLDER_CONNECTION =
  "TestBackupSampleFolderConnection";
export const TEST_BACKUP_FOLDER_CONNECTION_XML =
  "TestBackupFolderConnectionXML";
export const TEST_BACKUP_FOLDER_CONNECTION_XLS =
  "TestBackupFolderConnectionXLS";
export const TEST_BACKUP_FOLDER_CONNECTION_AL1 =
  "TestBackupFolderConnectionAL1";
export const BACKUP_SETTING_SUBMIT = "SubmitBackupSettings";
export const BACKUP_SETTING_SUBMIT_XML = "SubmitBackupSettingsXML";
export const BACKUP_SETTING_SUBMIT_AL1 = "SubmitBackupSettingsAL1";
export const GET_DOWNLOAD_SAMPLE_XML_ON_CREATE_SAMPLE =
  "GetDownloadSampleXMLOnCreateSample";
export const GET_DOWNLOAD_SAMPLE_XML_ON_APPROVE =
  "GetDownloadSampleXMLOnApprove";
export const GET_DOWNLOAD_SAMPLE_XLS_ON_APPROVE =
  "GetDownloadSampleXLSOnApprove";
export const GET_DOWNLOAD_SAMPLE_AL1_ON_APPROVE =
  "GetDownloadSampleAL1OnApprove";
export const UPDATE_DOWNLOAD_SAMPLE_XML_ON_CREATE_SAMPLE =
  "UpdateDownloadSampleXMLOnCreateSample";
export const UPDATE_DOWNLOAD_SAMPLE_XML_ON_APPROVE =
  "UpdateDownloadSampleMeasurementXMLOnApprove";
export const UPDATE_DOWNLOAD_SAMPLE_XLS_ON_APPROVE =
  "UpdateDownloadSampleMeasurementXLSOnApprove";
export const UPDATE_DOWNLOAD_SAMPLE_AL1_ON_APPROVE =
  "UpdateDownloadSampleMeasurementAL1OnApprove";
export const GET_NETWORK_PATH_CONFIG = "getNetworkPathConfig";
export const NETWORK_PATH_CONFIG = "NetworkPathConfig";
export const SETTINGS_GET_AUTO_DELETE = "getAutoDeleteSettings";
export const SETTINGS_POST_AUTO_DELETE = "AddAutoDeleteSettings";
export const SETTINGS_PUT_AUTO_DELETE = "updateAutoDeleteSettings";

// Backup and Restore
export const BACKUP_AND_RESTORE_GET_ALL = "getAllBackupAndRestore";
export const CREATE_BACKUP = "CREATE_BACKUP";
export const RESTORE_BACKUP = "RESTORE_BACKUP";

// Scanner
export const SCANNER_SETTING_GET_BY_ID = "getScannerSetting";
export const SCANNER_SETTING_GET_ALL = "getAllScannerSetting";
export const SCANNER_SETTING_SUBMIT = "submitScannerSetting";

// INSTRUMENT MEASUREMENT
export const GET_INSTRUMENT_SAMPLE_DETAILS = "getInstrumentSampleDetails";
export const SCANNER_SETTING_DELETE = "deleteScannerSetting";

//Trend

export const TREND_PROPERTY_DETAILS = "submitPropertyDetails";
export const TREND_PROPERTY_VALUES = "submitPropertValues";
export const TREND_RANGE_REPORT = "getTrendDateRange";

//Dashboard
export const DASHBOARD_SAMPLE_STATUS = "getSampleStatus";
export const DASHBOARD_INSTRUMENT_AVAILABILITY = "getInstrumentAvailability";
export const DASHBOARD_TOP5_ALARMS = "getTopPropertiesAlarmDetails";
export const DASHBOARD_ACTIVITYLOG = "getActivityLog";

export const SAMPLE_GET_DATE_FORMAT = "sampleGetDateFormat";
export const PROPERTY_CHECK_FORMULA = "propertyCheckFormula";

export const SAMPLE_LAST_INSTRUMENT_REMASURE =
  "sample_last_instruemnt_remasure";

export const SAMPLE_SKIP_COUNT_IN_POSITION = "sample_skip_count_in_position";
export const SAMPLE_END_POSITION = "sample_end_position";

export const LOGIN_DETAILS = "LoginDetails";

//LOGS

export const LOG_GET_BY_ID = "getLog";
export const LOG_GET_ALL = "getAllLog";
export const LOG_RANGE_REPORT = "getLogDateRange";

//LICENSE
export const LICENSE_UPLOAD_FILE = "uploadLicenseFile";
export const LICENSE_DETAILS = "getLicenseDetails";
